export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/valueOf.js
// module id = 422
// module chunks = 0